var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiButton',[_c('Button',{class:{
      active: _vm.active,
    },on:{"click":function($event){return _vm.selectType(_vm.type.id)}}},[_vm._v(" "+_vm._s(_vm.type.projectId)+" ")]),_c('Button',{class:{
      active: _vm.active,
    }},[_c('router-link',{attrs:{"to":{ name: 'Catalog Entry', params: { id: _vm.type.id } },"target":"_blank"}},[_c('ExternalLinkIcon',{attrs:{"size":16}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }